export default __webpack_public_path__ + "static/media/chargeguys_transparent_logo.4b75215b.png";